import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { selectCurrentHotels, selectLoggedinUserName } from '../../accessors/index'
import { getSubsidiaryList, postAndSelectSubsidiary } from '../../actions/index'
import { getSavedSubsidiary } from '../../utils/helpers'
import HotelSwitcher from './HotelSwitcher/index'
import styles from './Welcome.module.scss'

const Welcome = () => {
  const dispatch = useDispatch()

  const currentHotels = useSelector(selectCurrentHotels)
  const currentUserName = useSelector(selectLoggedinUserName)
  const isHotelPosted = useSelector(s => s.login.isSubsidiaryPosted)
  const isHotelPosting = useSelector(s => s.login.isSubsidiaryPosting)

  const [isCheckingSavedHotel, setIsCheckingSavedHotel] = useState(true)

  useEffect(() => {
    if (currentHotels.length === 0) {
      dispatch(getSubsidiaryList())
    }
  }, [currentHotels.length, dispatch])

  useEffect(() => {
    function autoSelectHotel(savedHotel) {
      const candidate = currentHotels.find(
        s => s.subsidiaryId === savedHotel.subsidiaryId
      )

      if (candidate) {
        dispatch(postAndSelectSubsidiary(savedHotel.subsidiaryId))
        setIsCheckingSavedHotel(false)
      } else {
        setIsCheckingSavedHotel(false)
      }
    }

    if (isHotelPosted || isHotelPosting) return // do nothing

    const savedHotel = getSavedSubsidiary()

    if (savedHotel && currentHotels?.length) {
      autoSelectHotel(savedHotel)
    }

    if (currentHotels.length === 1) {
      autoSelectHotel({ subsidiaryId: currentHotels[0].subsidiaryId })
    }

    if (currentHotels.length === 1 || (!savedHotel && currentHotels.length)) {
      setIsCheckingSavedHotel(false)
    }
  }, [currentHotels, dispatch, isHotelPosted, isHotelPosting])

  if (isCheckingSavedHotel) {
    return (
      <div className="full-screen-loading">
        <LoadingIndicator />
      </div>
    )
  }

  return (
    <div className={styles.hotelSelection}>
      <div className={styles.inner}>
        <div className={styles.hgroup}>
          <h1>Welcome back {currentUserName}</h1>
          <p className={styles.subtitle}>Select the hotel dashboard you want to log in</p>
        </div>
        <HotelSwitcher />
      </div>
    </div>
  )
}

export default Welcome
